module.exports = __webpack_public_path__ + "img/docker-svgrepo-com.5ac6cd63.svg";